import React from 'react';
import styled from 'styled-components';
import { displayFlexColCenterCenterMixin } from 'styles';
import useCalculatorRoundingStore from '../hooks/useCalculatorRoundingStore';
import CalculatorRoundingAnimationLottie from './CalculatorRoundingAnimationLottie';

const FormInputRoundingMask = ({
  mode,
  styles = {},
  isForceShowRoundingMask = false,
}) => {
  const { isCalculatorRounding } = useCalculatorRoundingStore();

  if (!isCalculatorRounding && !isForceShowRoundingMask) return null;
  return (
    <FormInputRoundingMaskStyled style={styles}>
      <CalculatorRoundingAnimationLottie
        mode={mode}
        width="25px"
        height="25px"
      />
    </FormInputRoundingMaskStyled>
  );
};

const FormInputRoundingMaskStyled = styled.div`
  position: absolute;
  height: 50px;
  padding-left: 16px;
  ${displayFlexColCenterCenterMixin};
`;

export default FormInputRoundingMask;
